module.exports = __webpack_public_path__ + "static/media/Group39.ac58cdaf.png";